import post from "@adora/shared/utils/post";
import { RelativeUrl as LambdaRelativeUrl } from "@adora/shared/utils/environment";
import { fetchBlobThroughDownloadApi } from "@adora/shared/utils/download";

export interface ResizerBaseParams {
  adAssetGroup: number;
  brandId: number;
}
export interface ResizerParams extends ResizerBaseParams {
  adImageIds: number[];
}

export async function resizeImages({ adAssetGroup, adImageIds, brandId }: ResizerParams) {
  const url = LambdaRelativeUrl + `/ad_asset_groups/${adAssetGroup}/images/resize`;
  const response = await post(url, {}, { ad_image_ids: adImageIds, brand_id: brandId });
  return response;
}

export async function downloadResizedImages({ adAssetGroup, brandId }: ResizerBaseParams) {
  const url = LambdaRelativeUrl + `/ad_asset_groups/${adAssetGroup}/images/download_resize`;
  const params = new URLSearchParams({ brand_id: brandId.toString() });
  return await fetchBlobThroughDownloadApi(url, params);
}
